import SecondaryAction, { SecondaryActionProps } from './SecondaryAction';

export type { SecondaryActionProps };
export default SecondaryAction;
